// extracted by mini-css-extract-plugin
export var hidden = "_nm-1";
export var visible = "_nm-0";